import React, { useEffect, useRef, useState } from 'react'
import { array, node, number, object, shape, string } from 'prop-types'
import { useMatch } from '@reach/router'

import { loadData } from '@jelly/utils'

export const UserActivityContext = React.createContext()

UserActivityProvider.propTypes = {
	activity: shape({
		results: array,
		search: object,
	}),
	children: node,
	path: string,
	userId: number,
}

/**
 * This is the User Activity Provider context component
 * We're able to set the user logged in status here so throughout the app we can access this information
 */
export function UserActivityProvider({ activity: { results, search }, children, path, userId }) {
	const [activityResults, setActivityResults] = useState(results)
	const [activitySearch, setActivitySearch] = useState(search)
	const [isLoading, setIsLoading] = useState(false)
	const match = useMatch(`${path}:page`)
	const page = (match && match.page) || 1

	const isFirstRender = useRef(true)

	useEffect(() => {
		if (!isFirstRender.current) {
			setIsLoading(true)
			loadData(`/api/activity-by-user-id/${userId}/${page}/`).then(({ results, search }) => {
				setActivityResults(results)
				setActivitySearch(search)
				setIsLoading(false)
			})
		}
		isFirstRender.current = false
	}, [userId, page])

	return (
		<UserActivityContext.Provider value={{ isLoading, activityResults, activitySearch }}>
			{children}
		</UserActivityContext.Provider>
	)
}
UserActivityProvider.propTypes = {}
